var map = {
	"./hangover-1-pc.png": 6601,
	"./hangover-2-pc.png": 2960,
	"./hangover-3-pc.png": 1695,
	"./hangover-4-pc.png": 1414,
	"./hangover-5-pc.png": 7861
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6398;
module.exports = webpackAsyncContext;